import React from "react";
import PropTypes from "prop-types";
import { Tag } from "antd";

const AccountInfo = ({ email, status, daysLeft }) => {
  return (
    <div>
      <b>Account info</b>
      <div>{email}</div>
      <div>
        <Tag
          style={{ width: "100%", textAlign: "center" }}
          color={status === "ACTIVE" ? "green" : "yellow"}
        >
          {status}
        </Tag>
        {daysLeft} days left
        <div>
          <a href={"https://apps.pdview.com.au/app/verifyemail"}>Verify now</a>
        </div>
      </div>
    </div>
  );
};

AccountInfo.propTypes = {
  email: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  daysLeft: PropTypes.number.isRequired
};

export default AccountInfo;



// WEBPACK FOOTER //
// ./src/views/components/account_info/AccountInfo.jsx